var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipseChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#003F88",
    stroke: "#ADC7E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9227 10.4013C21.3749 9.89129 22.1343 9.86372 22.6188 10.3397C23.1033 10.8157 23.1295 11.615 22.6773 12.125L14.2773 21.5987C13.8385 22.0935 13.1073 22.1364 12.6191 21.6959L8.41907 17.9064C7.91588 17.4524 7.85761 16.655 8.28891 16.1253C8.72022 15.5956 9.47778 15.5343 9.98097 15.9883L13.3076 18.9898L20.9227 10.4013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseChecked);
export default __webpack_public_path__ + "static/media/ellipse-checked.d04bc3ebbc6b6c2042284232d35efb8b.svg";
export { ForwardRef as ReactComponent };